import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ModalComponent, TranslateModule],
})
export class InfoDialogComponent {
  private dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);

  text = '';

  header = '';

  constructor() {
    const dialogRef = this.dialogRef;
    const data = inject(MAT_DIALOG_DATA);

    dialogRef.disableClose = true;
    this.text = data.text;
    this.header = data.title;
  }

  acknowledged() {
    this.dialogRef.close(true);
  }
}
